module.exports = __webpack_public_path__ + "static/media/right.30a8d35a.svg";